import { render, staticRenderFns } from "./CreateEvent.vue?vue&type=template&id=23ea0b8a"
import script from "./CreateEvent.vue?vue&type=script&lang=js"
export * from "./CreateEvent.vue?vue&type=script&lang=js"
import style0 from "./CreateEvent.vue?vue&type=style&index=0&id=23ea0b8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports